
<div v-if="disabled">
  <slot></slot>
</div>
<div v-else @scroll.passive="$emit('scroll', $event)" class="scroll-area" :class="classes" v-bind:style="newStyle">
  <slot></slot>
</div>
